import { render } from "./ReadonlyDescriptionField.vue?vue&type=template&id=21a72726&scoped=true&ts=true"
import script from "./ReadonlyDescriptionField.vue?vue&type=script&lang=ts"
export * from "./ReadonlyDescriptionField.vue?vue&type=script&lang=ts"

import "./ReadonlyDescriptionField.vue?vue&type=style&index=0&id=21a72726&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/hekate/hekate/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21a72726"]])

export default __exports__